import { COLORS, createComponentWrapperWithRef, styled, THEME_CONST, uiTokens } from '../../../theme'
import { MsdkStyledComponent } from '../../../utils'

/** @visibleName FormLayout */
export const FormWrapper: MsdkStyledComponent<any> = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  flex: 1;
`

const MuiFormHeaderWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== '$mode' && prop !== '$centered' && prop !== '$isModal',
})<{
  $mode?: string
  $centered?: boolean
  $isModal?: boolean
}>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  background-color: ${(props) => (props.$mode === 'Edit' && props.$centered ? COLORS.grey50 : COLORS.white.main)};

  &.modal-form-header {
    padding: 16px 16px 0 0;
  }
`

const NovaFormHeaderWrapper = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== '$mode' && prop !== '$centered' && prop !== '$isModal' && prop !== '$isFullScreen',
})<{
  $mode?: string
  $centered?: boolean
  $isModal?: boolean
  $isFullScreen?: boolean
}>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: ${(props) => (props.$isModal ? 0 : '0 24px')};

  background-color: ${(props) =>
    props.$mode === 'Edit' && props.$centered
      ? uiTokens.uiSurface.background
      : props.$isModal && !props.$isFullScreen
      ? uiTokens.uiSurface['wm-static']
      : uiTokens.uiSurface.interactive};

  &.modal-form-header {
    padding: ${(props) =>
      props.$isModal && props.$isFullScreen
        ? `${uiTokens.spacing.padding.medium}px ${uiTokens.spacing.padding.large}px ${uiTokens.spacing.padding.medium}px;`
        : `${uiTokens.spacing.padding.semiMedium}px ${uiTokens.spacing.padding.semiMedium}px ${uiTokens.spacing.padding.small}px ${uiTokens.spacing.padding.medium}px;`};
  }
  color: ${uiTokens.uiContent.emphasized};
  height: ${uiTokens.sizing.uiControl.height.large}px;
`

export const FormHeaderWrapper = createComponentWrapperWithRef<any>(
  {
    mui: MuiFormHeaderWrapper,
    nova: NovaFormHeaderWrapper,
  },
  'FormHeaderWrapper',
)

export const FormFooterWrapper: MsdkStyledComponent<any> = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isInModal',
})<{
  $isInModal?: boolean
}>`
  display: flex;
  padding: ${(props) => (props.$isInModal ? '16px 16px 0 0' : THEME_CONST.defaultPadding + 'px')};
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`
